Librarian.Modules.Reports = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-reports-",
        tabName: "Reports", 
        label: null, 
        subtabName: null
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || (!this.options.tabName)) {
            return;
        }
        var self = this;
        this.parent();

        this.wrapperEl.addOnClick(function(event) {
            event.preventDefault();
            event.stopPropagation();

            var tabName = (self.options.tabName || "Reports").trim().toLowerCase();

            if(self.options.subtabName) {
                var subtab = self.options.subtabName.toLowerCase().trim();

                if(subtab === "sales") {
                    Library.loadTabByName(tabName, null, "sales");
                } else if(subtab === "content") {
                    Library.loadTabByName(tabName, null, "content");
                } else if(subtab === "activities") {
                    Library.loadTabByName(tabName, null, "activities");
                }
                
            } else {
                Library.loadTabByName(tabName);
            }

        });

        var label = (this.options.label || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": Librarian.Lang.getString(label),
                "data-translation": label
            }).injectInside(this.containerEl);
        }
    }

});